import { api } from '@constants/constants';

const baseUrl = {
  dev: api.dev,
  prod: api.prod,
};

export default baseUrl;
